import React from "react";

const defaultFYData = ["Employees", "Workers"].flatMap((group) =>
  ["Male", "Female", "Total"].map((gender) => ({
    group,
    gender,
    current: {
      total: "",
      number: "",
      percentage: "",
    },
    previous: {
      total: "",
      number: "",
      percentage: "",
    },
  }))
);

const WorkforceFYTable = ({ fydata, setFyData }) => {
  const handleChange = (group, gender, period, field, value) => {
    const index = fydata.findIndex(
      (r) => r.group === group && r.gender === gender
    );
    if (index === -1) return;

    const updated = [...fydata];
    updated[index][period][field] = value;
    setFyData(updated);
  };

  const groups = ["Employees", "Workers"];
  const genders = ["Male", "Female", "Total"];

  return (
    <div
      style={{
        marginTop: "20px",
        overflowX: "auto",
        border: "1px solid #000",
        overflow: "hidden",
        borderRadius: "8px",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th rowSpan="2" style={headerStyle}>
              category
            </th>
            <th colSpan="3" style={headerStyle}>
              FY ____
              <br />
              Current Financial Year
            </th>
            <th colSpan="3" style={headerStyle}>
              FY ____
              <br />
              Previous Financial Year
            </th>
          </tr>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th style={headerStyle}>Total (A)</th>
            <th style={headerStyle}>No. (B)</th>
            <th style={headerStyle}>% (A/B)</th>
            <th style={headerStyle}>Total (C)</th>
            <th style={headerStyle}>No. (D)</th>
            <th style={headerStyle}>% (D/C)</th>
          </tr>
        </thead>
        <tbody>
          {groups.map((group) => (
            <React.Fragment key={group}>
              <tr>
                <td
                  colSpan="7"
                  style={{ ...groupHeaderStyle, backgroundColor: "#D3C9CE" }}
                >
                  {group}
                </td>
              </tr>
              {genders.map((gender) => {
                const row = fydata.find(
                  (r) => r.group === group && r.gender === gender
                );
                if (!row) return null;

                return (
                  <tr key={`${group}-${gender}`}>
                    <td
                      style={{
                        ...cellStyle,
                        backgroundColor: "#D3C9CE",
                        fontWeight: "bold",
                      }}
                    >
                      {gender}
                    </td>

                    {/* Current FY */}
                    <td style={cellStyle}>
                      <input
                        type="text"
                        value={row.current.total}
                        onChange={(e) =>
                          handleChange(
                            group,
                            gender,
                            "current",
                            "total",
                            e.target.value
                          )
                        }
                        style={inputStyle}
                        placeholder="Enter"
                      />
                    </td>
                    <td style={cellStyle}>
                      <input
                        type="text"
                        value={row.current.number}
                        onChange={(e) =>
                          handleChange(
                            group,
                            gender,
                            "current",
                            "number",
                            e.target.value
                          )
                        }
                        style={inputStyle}
                        placeholder="Enter"
                      />
                    </td>
                    <td style={cellStyle}>
                      <input
                        type="text"
                        value={row.current.percentage}
                        onChange={(e) =>
                          handleChange(
                            group,
                            gender,
                            "current",
                            "percentage",
                            e.target.value
                          )
                        }
                        style={inputStyle}
                        placeholder="Enter"
                      />
                    </td>

                    {/* Previous FY */}
                    <td style={cellStyle}>
                      <input
                        type="text"
                        value={row.previous.total}
                        onChange={(e) =>
                          handleChange(
                            group,
                            gender,
                            "previous",
                            "total",
                            e.target.value
                          )
                        }
                        style={inputStyle}
                        placeholder="Enter"
                      />
                    </td>
                    <td style={cellStyle}>
                      <input
                        type="text"
                        value={row.previous.number}
                        onChange={(e) =>
                          handleChange(
                            group,
                            gender,
                            "previous",
                            "number",
                            e.target.value
                          )
                        }
                        style={inputStyle}
                        placeholder="Enter"
                      />
                    </td>
                    <td style={cellStyle}>
                      <input
                        type="text"
                        value={row.previous.percentage}
                        onChange={(e) =>
                          handleChange(
                            group,
                            gender,
                            "previous",
                            "percentage",
                            e.target.value
                          )
                        }
                        style={inputStyle}
                        placeholder="Enter"
                      />
                    </td>
                  </tr>
                );
              })}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Styles
const headerStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
  width: "14.2%", // 7 columns = 100 / 7
  wordWrap: "break-word",
};

const groupHeaderStyle = {
  padding: "10px",
  backgroundColor: "#e7dfe2",
  fontWeight: "bold",
  border: "1px solid #000",
  textAlign: "center",
};

const cellStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
  width: "14.2%",
};

const inputStyle = {
  width: "100%",
  padding: "8px 10px",
  fontSize: "14px",
  borderRadius: "4px",
  border: "1px solid grey",
  outline: "none",
  boxSizing: "border-box",
};

export default WorkforceFYTable;
